import React from "react";
import { Box, Menu as MenuChakra } from "@chakra-ui/react";
import type { IContentHeader } from "../../..";
import MenuButton from "./MenuButton";
import MenuItem from "./MenuItem";
import MenuList from "./MenuList";
import { observer } from "mobx-react-lite";
import addAnalyticSanitize from "../../../../../hooks/useAnalytics/functions/addAnalyticSanitize";
import { colors } from "../../../../../theme/colors";
import { useNavigateCustom } from "../../../../../hooks";

const Menu: React.FC<IContentHeader> = observer(({ menu, subMenu, onTriggerTagging }) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const navigate = useNavigateCustom();

	const onClickButton = (): React.ReactElement | void => {
		onTriggerTagging!(menu.label);
		if (menu.link) {
			if (menu.newTab) {
				window.open(menu.link);
				return;
			}
			return navigate(menu.link);
		}
	};

	const onClickMenuItem = (label: string, link?: string, newTab?: boolean, external?: boolean): React.ReactElement | void => {
		onTriggerTagging!(label, `${addAnalyticSanitize(menu.label)}`);
		if (link) {
			setIsOpen(false);
			if (newTab || external) {
				window.open(link, newTab ? "_blank" : "_self");
				return;
			}
			return navigate(link);
		}
	};

	return (
		<MenuChakra isOpen={isOpen} gutter={0}>
			<MenuButton onClick={onClickButton} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
				{menu.label}
			</MenuButton>
			{subMenu && (
				<Box onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
					<MenuList zIndex={999}>
						<>
							{subMenu.map(({ label, link, newTab, external }) => (
								<MenuItem key={label} onClick={() => onClickMenuItem(label, link, newTab, external)} pointerEvents={"auto"} textColor={colors.black[500]}>
									{label}
								</MenuItem>
							))}
						</>
					</MenuList>
				</Box>
			)}
		</MenuChakra>
	);
});

export default Menu;
